import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

// Floating button for toggling the chat window visibility
export default function FloatingButton({ onClick }) {
  // State to track if the button is expanded
  const [isExpanded, setIsExpanded] = useState(null);

  // Effect to trigger the expansion after a 10-second delay
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsExpanded(true);
    }, 10000); // 10 seconds delay

    return () => clearTimeout(timer);
  }, []);

  // Determine the button class based on the expanded state
  const buttonClass = isExpanded ? 'bf-expand-chat expanded' : 'bf-expand-chat';

  // When an element with .trigger-shop-assistant is clicked, trigger the button
  useEffect(() => {
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('trigger-shop-assistant')) {
        onClick();
      }

      // if the element has a class of .trigger-shop-assistant, trigger the button or link inside of it
      if (event.target.closest('.trigger-shop-assistant')) {
        onClick();
      }

      // add support when data-trigger-shop-assistant is used
      if (
        event.target.getAttribute &&
        event.target.getAttribute('data-trigger-shop-assistant')
      ) {
        onClick();
      }
    });
  }, []);

  return (
    <button
      onClick={onClick}
      aria-label='Open Shopping Assistant'
      className={buttonClass}
    >
      <span className='icon-text'>
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512'>
          <path d='M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z' />
        </svg>
        <span className='text'>Shop now</span>
      </span>
    </button>
  );
}

FloatingButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
